module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/icb/detail/details.component.scss
// module id = 894
// module chunks = 10